import { useEffect, useState } from "react";
import { api } from "../api";
import { Pill, actionPillKind, actionLabel } from "../components/Pill";

const CATEGORY_LABEL: Record<string, string> = {
  pii: "Personal Identifiers",
  legal_client_matter: "Client and Matter Data",
  contract_text: "Contract Text",
  source_code: "Source Code and IP",
  credentials: "Credentials and Secrets",
  financials: "Financials",
  internal_project_names: "Internal Project Names",
  generic_structured: "Structured Sensitive Content",
};

export function PoliciesPage() {
  const [rules, setRules] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    const res = await api.getPolicyBundle();
    setRules(res.rules);
    setLoading(false);
  }
  useEffect(() => { load(); }, []);

  async function toggle(rule: any) {
    const next = { ...rule, enabled: !rule.enabled };
    await api.updateRule({ rule: next });
    setRules((rs) => rs.map((r) => r.id === rule.id ? next : r));
  }
  async function changeAction(rule: any, action: string) {
    const next = { ...rule, action };
    await api.updateRule({ rule: next });
    setRules((rs) => rs.map((r) => r.id === rule.id ? next : r));
  }

  if (loading) return <div className="sg-empty">Loading…</div>;

  const grouped: Record<string, any[]> = {};
  for (const r of rules) (grouped[r.category] ??= []).push(r);

  return (
    <>
      <header className="sg-page-header">
        <h1 className="sg-page-title">Policies</h1>
        <div className="sg-page-sub">Rule Library · Scoped Workspace-Wide</div>
      </header>

      {Object.entries(grouped).map(([cat, list]) => (
        <section key={cat} style={{ marginBottom: 32 }}>
          <div className="sg-section-label">{CATEGORY_LABEL[cat] ?? cat}</div>
          <div className="sg-panel">
            <table className="sg-table">
              <thead>
                <tr>
                  <th style={{ width: "36%" }}>Rule</th>
                  <th>Severity</th>
                  <th>Action</th>
                  <th>Status</th>
                  <th style={{ textAlign: "right" }}>Manage</th>
                </tr>
              </thead>
              <tbody>
                {list.map((r) => (
                  <tr key={r.id}>
                    <td>
                      <div style={{ fontWeight: 500 }}>{r.name}</div>
                      <div className="sg-muted" style={{ fontSize: 12, marginTop: 2 }}>{r.description}</div>
                    </td>
                    <td><Pill kind="neutral">{r.severity}</Pill></td>
                    <td>
                      <select
                        className="sg-select"
                        value={r.action}
                        onChange={(e) => changeAction(r, e.target.value)}
                        style={{ padding: "4px 8px", fontSize: 12 }}
                      >
                        <option value="allow">Allow</option>
                        <option value="warn">Warn</option>
                        <option value="suggest_rewrite">Rewrite</option>
                        <option value="block">Block</option>
                      </select>
                    </td>
                    <td>
                      <Pill kind={r.enabled ? actionPillKind(r.action) : "neutral"}>
                        {r.enabled ? actionLabel(r.action) : "Disabled"}
                      </Pill>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <button className="sg-btn sg-btn-sm" onClick={() => toggle(r)}>
                        {r.enabled ? "Disable" : "Enable"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      ))}
    </>
  );
}
